export const SET_LOADING_DATA = '@clientPositionReport/SET_LOADING_DATA';
export const GET_LIST_ALL_REQUEST = '@clientPositionReport/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@clientPositionReport/GET_LIST_ALL_SUCCESS';
export const SET_PAGE = '@clientPositionReport/SET_PAGE';
export const SET_ROWS_COUNT = '@clientPositionReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@clientPositionReport/SET_ROWS_PER_PAGE';
